<div class="phase-detail">

    <mat-tab-group [(selectedIndex)]="phaseTabIndex" class="tabs" dynamicHeight>

        @for (phaseId of phases; track phaseId) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="label">
                        <img alt="{{'PHASE.' + phaseId.toUpperCase() | translate}}"
                             src="assets/images/moon/moon_{{phaseId}}.webp">
                        {{ 'PHASE.' + phaseId.toUpperCase() | translate }}
                    </div>
                </ng-template>
                <article class="description">
                    <h2>
                        {{ 'PHASE.' + phaseId.toUpperCase() | translate }}
                    </h2>
                    <p [innerHTML]="'PHASE_INFO.' + phaseId.toUpperCase()  | translate"></p>
                </article>
            </mat-tab>
        }

    </mat-tab-group>


</div>
